import React, { useRef, useEffect } from 'react';
import Observer from 'react-intersection-observer';
import RightArrowRed from '../../images/arrow__right-red.svg';

import { fireTag } from '../../libs/analytics';

import { isEs } from "../../libs/lang";

function SearchForm() {
	return (
		<Observer
			tag='section'
			className="search-controls"
			triggerOnce
			threshold={0.25}
			onChange={inView => {
				if (inView) {
					//fireTag("S4");
				}
			}}
		>
			<h2 tabIndex="-1" className="search-copy">
				<div className="container es">
					{
						isEs() ?
							<>
								Mira cómo estamos abordando el acceso a la vivienda a precio asequible en todo el país
							</> :
							<>
								See how we’re addressing housing affordability across the country
							</>
					}

				</div>
				<a href="/impact/map/?category=organizations-housing" onClick={() => {
					fireTag("C4");
				}}>
					{
						isEs() ?
							<>
								Consulta el mapa (en inglés)
							</> :
							<>
								See the map
							</>
					}
					<img alt="Right Arrow Red" src={RightArrowRed}/>
				</a>
			</h2>
		</Observer>
	)
}

const HousingMap = ({
						uiState,
						handleEvent,
						chooseDropdownType,
						mapLoading,
						alreadyShown,
						location,
						results,
						checkForCityOrZip,
					}) => {

	const {showFilter, input} = uiState;
	const filterExpanded = () => !!showFilter;
	const containerRef = useRef(null)

	let scrollMap = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/housing/') && !scrollMap && document.querySelector('#find-local').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollMap = true;
				fireTag('S4');
			}
		});
	},[])

	return (
		<section className="housing-page map" id="find-local" ref={containerRef} data-tracking="scroll-housing-map"
		>
			{/* MAP */}
			<div className="map-container">
				<h2 tabIndex="-1" className="headline-overlay es">
					{
						isEs() ?
							<>
								Mira cómo estamos abordando el acceso a la vivienda a precio asequible en todo el país
							</> :
							<>
								See how we’re addressing housing affordability across the country
							</>
					}
					<div>
						<a
							href="/impact/map/?category=organizations-housing"
							onClick={() => {
								//GAfireEvent('housing_C5');
								fireTag("C4");
							}}>
							{
								isEs() ?
									<>
										Consulta el mapa (en inglés)
									</> :
									<>
										See the map
									</>
							}
							<img alt="Right Arrow Red" src={RightArrowRed}/>
						</a>
					</div>
				</h2>
				<a
					href="/impact/map/?category=organizations-housing"
					onClick={() => {
						fireTag("C4");
						//GAfireEvent('housing_C6');
					}}
				>
					<figure className="map-image" aria-label={isEs() ? "Mapa de los 50 estados contiguos de Estados Unidos con ciudades marcadas con puntos." : "Map of the contiguous United States with cities marked with dots."}/>
				</a>
			</div>
			<div className="map-overlay">
				<SearchForm
					handleEvent={handleEvent}
					input={input}
					results={results}
					checkForCityOrZip={checkForCityOrZip}
					chooseDropdownType={chooseDropdownType}
					location={location}
					filterExpanded={filterExpanded}
					showFilter={showFilter}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
				/>
			</div>
		</section>
	);
}

export default HousingMap;

